import { format, formatDistanceToNow } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz'
// ----------------------------------------------------------------------

export function fDate(date, type = "yyyy-MM-dd") {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', type);
  }
  return 'Invalid Date'
}

export function fMonth(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'MMM');
  }
  return 'Invalid Month'
}

export function fDay(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd');
  }
  return 'Invalid Day'
}

export function fYear(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'yyyy');
  }
  return 'Invalid Year'
}

export function fDateTime(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd MMM yyyy HH:mm');
  }
  return 'Invalid Date'
}

export function fDateTimeSuffix(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd/MM/yyyy hh:mm p');
  }
  return 'Invalid Date'
}

export function fToNow(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
    });
  }
  return 'Invalid Date'
}
